export type Flags = {
	usercan: boolean;
	isAssigned: boolean;
	userOwnsProduct: boolean; // dla nadchodzących false
	canSignUp: boolean;
	canGetAccessForFree: boolean;
};

type AccessState =
	| "UNAVAILABLE"
	| "CAN_SIGN_UP"
	| "ASSIGNED_WAITING"
	| "ACCESS_GRANTED"
	| "ACCESS_GRANTED_FREE"
	| "REQUIRES_PAYMENT"
	| "ERROR";

export const determineAccessState = (flags: Flags): AccessState => {
    if (flags.isAssigned) {
		return "ASSIGNED_WAITING";
	}

    if (flags.canSignUp) {
		return "CAN_SIGN_UP";
	}

	if (flags.usercan) {
		return flags.canGetAccessForFree ? "ACCESS_GRANTED_FREE" : "ACCESS_GRANTED";
	}

	if (!flags.usercan && flags.canGetAccessForFree) {
		return "ACCESS_GRANTED_FREE";
	}

	if (!flags.usercan && !flags.canSignUp && !flags.canGetAccessForFree) {
		return "REQUIRES_PAYMENT";
	}

	return "UNAVAILABLE";
}
